/*
  E-Mobility: devuelve el menu a transparente mientras pasa por encima de una
  seccion marcada con `data-header-transparente` -hoy, el video del home-.

  El theme solo tiene dos estados: arriba del todo es transparente y, apenas
  se scrollea, se vuelve solido (`shopify-section-header-sticky`). Sobre un
  video a pantalla completa ese blanco corta la escena en dos. Aqui se agrega
  `header--sobre-media` al encabezado cuando la franja del menu cae dentro de
  la seccion, y el CSS de `header-assets-transparent` hace el resto.

  Se mide contra el punto medio del menu, no contra su borde: con el borde, el
  cambio ocurre un pelo antes de que el fondo del video este detras y se ve un
  parpadeo al entrar y al salir.
*/
(function () {
  var MARCA = '[data-header-transparente]';
  var CLASE = 'header--sobre-media';
  var pedido = null;
  var puesto = false;

  function encabezado() {
    return document.querySelector('.section-header');
  }

  function revisar() {
    pedido = null;
    var header = encabezado();
    if (!header) return;

    var zonas = document.querySelectorAll(MARCA);
    if (!zonas.length) {
      if (puesto) {
        header.classList.remove(CLASE);
        puesto = false;
      }
      return;
    }

    var barra = header.querySelector('.header') || header;
    var medio = (barra.clientHeight || 0) / 2;
    var encima = false;

    for (var i = 0; i < zonas.length; i++) {
      var caja = zonas[i].getBoundingClientRect();
      if (caja.top <= medio && caja.bottom >= medio) {
        encima = true;
        break;
      }
    }

    if (encima !== puesto) {
      header.classList.toggle(CLASE, encima);
      puesto = encima;
    }
  }

  function alMoverse() {
    if (pedido === null) pedido = window.requestAnimationFrame(revisar);
  }

  function arrancar() {
    if (document.documentElement.dataset.headerSobreMedia === '1') {
      revisar();
      return;
    }
    document.documentElement.dataset.headerSobreMedia = '1';
    window.addEventListener('scroll', alMoverse, { passive: true });
    window.addEventListener('resize', alMoverse);
    revisar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  // el editor de temas monta y desmonta secciones sin recargar la pagina
  document.addEventListener('shopify:section:load', alMoverse);
  document.addEventListener('shopify:section:unload', alMoverse);
  document.addEventListener('shopify:section:select', alMoverse);
})();
